import { contenuPosePushVideoMock, titreBudgetMock } from '@mock/schema/components';
import { pageBase } from '@mock/schema/slugs/config';
import { SlugPage } from '@pages/slug-page/models';

const blocks = [titreBudgetMock('pose-pro'), contenuPosePushVideoMock];

export const laPoseProMock: SlugPage = {
  ...pageBase({
    title: 'La Pose Pro',
    type: 'la-pose',
    language: 'fr-FR',
    headerId: 'header-fr',
    footerId: 'footer-fr',
    isBreadcrumbOverlay: false,
  }),
  blocks,
};
